export default "__VITE_ASSET__Dp9ke6Uq__"